<template>
    <poverty-visualization :charts="charts" :area-chart="areaChart" :line-chart="lineChart" :title="title" :metric="metric" :y-domain="yDomain" :numeral-format="numeralFormat"></poverty-visualization>
</template>
<script>
    import PovertyVisualization from './PovertyVisualization';
    export default{
        data: function(){
            return {
                title: 'Promedio Mensual del Ingreso de Trabajo',
                metric: 'ingresos',
                yDomain: [0,1400000],
                numeralFormat: '0,0',
                charts: [
                    {
                        id: 'zona',
                        title: 'Zonas Urbanas y Rurales',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vT2xYFKg6BYVK8nkiAAPrelTTy3oJH5XAHjqYsS4vMjr--Zubfahs2CWC68OOlaCOfmJfKAODrFSKEM/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTvU8brY9Ct-jMtn5Mix5S3-EZ5dQ45KUUXWyLDvTBnkG_YCenV8XuLmKAMqIxOgIrIA1DiGCSdql70/pub?gid=0&single=true&output=csv',
                        dimensions: ['region','zona']
                    },
                    {
                        id: 'quintil',
                        title: 'Quintiles',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQFFM74fNwIBXfLyDzOlE_vHPp8k70cKl5g1tqqR4yaOdR6cbuR2lBc0OwBDiW9q6Z9yyHKIrXa-Hzo/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSgwJ7fvRf-VErROtLWSO90tipOECNsQZbV215LYGdauhF2vts07K6p2rrbOr36vKKARj64vqcMB_WU/pub?gid=0&single=true&output=csv',
                        dimensions: ['region','quintil']
                    },
                    {
                        id: 'migrantes',
                        title: 'Migrantes',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQYq1aIyUkNY_29zeHbAAcQYUgQ_bzQ5fNLbOOCHQyVRyl3wkMx-C6zNe7cYa1j-ceI8UjBweMa4H-W/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSnT4tOsDJwR5yG7oZWr8EgANoSo7Q4zlN_8AJmKdWC0rsYxFqH2IgTHMyHU9YHeZLpkvyJmpejVQcC/pub?gid=0&single=true&output=csv',
                        dimensions: ['region','migrantes']
                    },
                    {
                        id: 'indigena',
                        title: 'Pueblos Originarios',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSB8ksao7J0lGFRBZLlIFzDJIGw-1xawjPoRzQhuz-lhxzA5LaCFKRtf9rNVU43f0UZohuqeeZXSLdk/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSC76x6HCvrHh8ucFoLDucUxTfDixpqXOwNx0M8PCsWrrnx7NHYv3pmfeWBVlPgAXCC4bavAaVqAb_m/pub?gid=0&single=true&output=csv',
                        dimensions: ['region','indigena']
                    },
                    {
                        id: 'genero',
                        title: 'Genero',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR-jNEU66MoMRzvXqp-CxVYR1Tja0w9-SNXjYAxJuO_JLrL43tgESuDrWI7UDUkalgbDKxtLYKjDZdC/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQlMtmnV28ec7a_qIBTP02ZX2DaXCBq6glUagvji2oTA75EmCBPEqi7vraPwYj_Y8CU7ci1Ye-Z-cAr/pub?gid=0&single=true&output=csv',
                        dimensions: ['region','genero']
                    },
                    {
                        id: 'edades',
                        title: 'Rango Etario',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSQMJI8dWDR5FdwuNLEFIFA2dwWNUcXmfoD6km2wmnwEvVpLNFvmfNAVzgbB3G_aj8wTAA699Z11_m1/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQomoUTub2L1KIOHlU_eGq9TmeqgnGlKb6AB4y3gGCtEA_i3FAZdet-0kGL4SC3TDU6WwlHucRFgQTz/pub?gid=0&single=true&output=csv',
                        dimensions: ['region','edades']
                    },
                ],
                areaChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSSJCp0Gso_YlU6mV3k7WuS3F_g5RK1RoEyNERp7fGvrmbMm5kV0CTOM0QWtQaIOp2tyeruI4QzlS9s/pub?gid=0&single=true&output=csv'
                },
                lineChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTEnLAjVsky2G0qRb2mWkPHvQI4SGKjaIaeE7eDy77z9xZAYjOLoNggGpf_LpD3vqlsinAr7cSVGB3c/pub?gid=0&single=true&output=csv'
                }
            }
        },
        components: {
            PovertyVisualization
        }

    }
</script>


// WEBPACK FOOTER //
// src/js/Components/Visualizations/LaborIncomeVisualization.vue